import { isEmptyObject } from "utils";

import { FILTER_COLUMNS } from "constants/filterConstants";

export const areStatusActiveProgramFiltersEmpty = (filters: any) =>
  isEmptyObject(filters) ||
  (filters[FILTER_COLUMNS.PUBLISH_STATUS]?.length ?? 0) +
    (filters[FILTER_COLUMNS.ACTIVE_PROGRAMS]?.length ?? 0) ===
    0;

export const areStatusFiltersEmpty = (filters: any) =>
  isEmptyObject(filters) ||
  (filters[FILTER_COLUMNS.PUBLISH_STATUS]?.length ?? 0) === 0;
